import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Zap, Menu, X, ShoppingCart, Phone, MapPin, Clock } from "lucide-react";
import { useCart } from "../context/CartContext";

const nav = [
  { to: "/", label: "Acasa" },
  { to: "/magazin", label: "Magazin" },
  { to: "/piese", label: "Piese" },
  { to: "/servicii", label: "Service" },
  { to: "/programare", label: "Programare" },
  { to: "/contact", label: "Contact" },
];

export const PublicHeader = () => {
  const [open, setOpen] = useState(false);
  const { count } = useCart();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-[#00E5FF]/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3 group">
          <div className="w-9 h-9 bg-[#00E5FF] flex items-center justify-center tx-cyan-glow group-hover:rotate-6 transition-transform">
            <Zap className="w-5 h-5 text-black" fill="currentColor" />
          </div>
          <div className="font-display text-lg text-white tracking-tight">
            TROTI<span className="text-[#00E5FF]">-X</span>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-7">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `text-xs uppercase tracking-[0.2em] font-semibold transition-colors ${isActive ? "text-[#00E5FF]" : "text-neutral-400 hover:text-white"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/cos" data-testid="header-cart-btn" className="relative p-2 text-white hover:text-[#00E5FF] transition-colors">
            <ShoppingCart className="w-5 h-5" />
            {count > 0 && (
              <span data-testid="cart-count-badge" className="absolute -top-1 -right-1 bg-[#00E5FF] text-black text-[10px] font-bold min-w-[18px] h-[18px] flex items-center justify-center rounded-full">
                {count}
              </span>
            )}
          </Link>
          <button data-testid="mobile-menu-btn" onClick={() => setOpen(!open)} className="md:hidden p-2 text-white">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden bg-black border-t border-[#00E5FF]/15 px-6 py-4 space-y-3">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)}
              className={({ isActive }) => `block text-sm uppercase tracking-widest font-semibold ${isActive ? "text-[#00E5FF]" : "text-neutral-300"}`}>
              {n.label}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
};

export const PublicFooter = () => (
  <footer className="border-t border-[#00E5FF]/15 bg-[#030303] mt-20">
    <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-12">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 bg-[#00E5FF] flex items-center justify-center">
            <Zap className="w-5 h-5 text-black" fill="currentColor" />
          </div>
          <div className="font-display text-lg">TROTI<span className="text-[#00E5FF]">-X</span></div>
        </div>
        <p className="text-sm text-neutral-500 leading-relaxed">
          Magazin si service de trotinete electrice in Timisoara. Vanzari, reparatii si garantii — partener{" "}
          <span className="text-[#00E5FF]">trotinete-ieftine.ro</span>.
        </p>
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] font-bold mb-4">// Navigare</div>
        <div className="space-y-2.5">
          {nav.map((n) => (
            <Link key={n.to} to={n.to} className="block text-sm text-neutral-400 hover:text-[#00E5FF] transition-colors">{n.label}</Link>
          ))}
        </div>
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] font-bold mb-4">// Contact</div>
        <div className="space-y-3 text-sm text-neutral-400">
          <div className="flex items-center gap-2.5"><Phone className="w-4 h-4 text-[#00E5FF]" /> 0743 110 277</div>
          <div className="flex items-center gap-2.5"><MapPin className="w-4 h-4 text-[#00E5FF]" /> Bd. Liviu Rebreanu 104A, Timisoara</div>
          <div className="flex items-center gap-2.5"><Clock className="w-4 h-4 text-[#00E5FF]" /> L-V 9-17 · Sambata 9-14</div>
        </div>
      </div>
    </div>
    <div className="border-t border-neutral-900 py-5 text-center text-[11px] uppercase tracking-widest text-neutral-600">
      © {new Date().getFullYear()} TROTI-X · Timisoara
    </div>
  </footer>
);
